/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.5.0-nightly.2026.7.27",
    versionName: "0.5.0-nightly.2026.7.27",
    versionChannel: "nightly",
    buildDate: "2026-07-27T00:29:13.921Z",
    commitHash: "7eddfaea63f0e74692d7ff3d08dacc48e0cfe770",
};
